const state = {
    journalentry: [],
    id: [],
    loading: false
};

export default state;